import 'core-js/es6/promise';
import 'core-js/es6/string';
import 'core-js/es7/array';

import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import App from './App';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/index.css';
import Loader from './UI/components/Loader';
import Positioned from './UI/components/Positioned';
import router from './router';
import store from './store';
import HasPermissions from './UI/directives/HasPermissions';

store.subscribe(mutation => {
  if(mutation.type === 'SET_AUTH_USER'){
    const authUser = mutation.payload;
    if(authUser && authUser.permissions)
      Vue.directive('has-permissions', HasPermissions(authUser.permissions.map(p => p.genericName)));
    else
      Vue.directive('has-permissions', HasPermissions([]));
  }
});

Vue.use(VueToast);

Vue.use(BootstrapVue);
Vue.component('Loader', Loader);
Vue.component('Positioned', Positioned);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: {
    App
  }
})
